<div #homeContainer class="home-container">
  <p class="home-default">{{ subtitle }}</p>
  <h2 class="digital">[{{ title }}]</h2>
  <div class="timer digital" *ngIf="timeLeft$ | async as t; else sorry">
    <span class="countdown"> {{ t.daysToDday }} </span>:
    <span class="countdown"> {{ t.hoursToDday }} </span>:
    <span class="countdown"> {{ t.minutesToDday }} </span>:
    <span class="countdown"> {{ t.secondsToDday }} </span>:
    <span class="countdown"> {{ t.milisecondsToDday }} </span>
  </div>

  <ng-template #sorry> Sorry, something went wrong... </ng-template>
</div>
